module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/bg_data-b1aecd31d786fffe9529e50ac9f30d60.jpg";